<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500" persistent> 
  
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text py-2">
            Ver documento
            <v-spacer></v-spacer>
            <v-btn color="white" text @click="dialog=false">
              X
            </v-btn>
          </v-card-title>
  
          <v-card-text class="pt-2">  
            <object ref="refObjeto"/>
          </v-card-text> 
  
          <v-card-actions>
            <v-btn color="red" outlined @click="dialog=false">
                Cerrar
            </v-btn>
            <v-spacer></v-spacer> 
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import { ref } from 'vue';

export default {
  data () {
    const dialog = ref(false); 
    const cargados = ref([]); 

    const openmodal = (ups) => { 
        cargados.value = ups;
        dialog.value = true;  
        window.console.log('docper', ups);
        
        let archivo = ups.archivo;  
        const url = `data:${archivo.mimetype};base64,${archivo.file64}`;    

        setTimeout(() => {
            this.$refs.refObjeto.data = url;
            this.$refs.refObjeto.type = archivo.mimetype;
            this.$refs.refObjeto.width = '100%';
            this.$refs.refObjeto.height = '600px';
        }, 300);
    }  

    return { 
        dialog, 
        openmodal
    }
  },
}
</script>